module.exports = __webpack_public_path__ + "static/media/turing-logo.49939236.png";